export default __webpack_public_path__ + "static/media/ArtificialIntelligence_UninformedSearch.bef18baa.zip";